// Mirrors `parsePublishedFileNames` in mediajel-gql-service's
// get-hashed-email-partition-download-url.ts resolver: `csvFileName` stores
// the published partition filenames on the audience record, comma-separated
// when there are several. Parse defensively — trim each entry, drop empties,
// and treat a null/undefined/empty field (an audience that has not
// published yet) as "no partitions available" rather than throwing.
export const parseCsvFileNames = (csvFileName) => {
  if (!csvFileName || typeof csvFileName !== "string") {
    return [];
  }
  return csvFileName
    .split(",")
    .map((name) => name.trim())
    .filter((name) => name.length > 0);
};

export default parseCsvFileNames;
